import React, { Fragment, useState } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { Container, Row } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import AgeingReportModal from "./ageingReportModal";

import { useEffect } from "react";
import {
  exportToExcelAgeingReport,
  getConsolidateAgeingReport,
  getConsolidateAgeingReportWithFilters,
  getFutureOverDueDetailsByAsm,
  getUserListByGroup,
} from "../../api/service";
import CommonLoader from "../../common/commonLoader";
import moment from "moment";
import CommonAccordion from "../../common/commonAccordion";
import {
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import {
  PersonSearch,
  Refresh,
  SimCardDownloadRounded,
} from "@mui/icons-material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import AgeingReportLiveSection from "./ageingReportLiveSection";
import AgeingReportHistorySection from "./ageingReportHistorySection";
import AgeingReportFutureOD from "./ageingReportFutureOD";

// Styles
import "./ageingReport.scss"; // adjust path accordingly

const useStyles = makeStyles((theme) => ({
  btnClass: {
    padding: "0.5rem 1.5rem!important",
    fontWeight: 600,
  },
  muiGrid: {
    marginTop: "-2vh",
    [theme.breakpoints.down("sm")]: {
      lineHeight: 5,
    },
  },
}));

const OldAgeingReport = () => {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const classes = useStyles();

  const [agingReportDataByRegion, setAgingReportDataByRegion] = useState([]);
  const [agingReportDataByState, setAgingReportDataByState] = useState([]);

  const [inactiveDtoListByRegion, setInactiveDtoListByRegion] = useState([]);
  const [dtoListByRegionOdMoreThan150, setDtoListByRegionOdMoreThan150] =
    useState([]);

  const [dtoListByPaymentClass, setDtoListByPaymentClass] = useState([]);

  const [inactiveDtoListByState, setInactiveDtoListByState] = useState([]);
  const [dtoListByStateOdMoreThan150, setDtoListByStateOdMoreThan150] =
    useState([]);

  const [totalOverdueByRegionByMonthList, setTotalOverdueByRegionByMonthList] =
    useState([]);
  const [totalOverdueByStateByMonthList, setTotalOverdueByStateByMonthList] =
    useState([]);
  const [
    totalProvisionAmountByRegionByMonthList,
    setTotalProvisionAmountByRegionByMonthList,
  ] = useState([]);
  const [
    totalProvisionAmountByStateByMonthList,
    setTotalProvisionAmountByStateByMonthList,
  ] = useState([]);
  const [modalData, setModalData] = useState([]);
  const [modalDataWithoutDivision, setModalDataWithoutDivision] = useState([]);
  const [asmList, setAsmList] = useState([]);
  const [futureODList, setFutureODList] = useState([]);
  const [futureODProvListByRegion, setFutureODProvListByRegion] = useState([]);
  const [futureODProvListByState, setFutureODProvListByState] = useState([]);
  const [
    futureODProvListByRegionPartyWise,
    setFutureODProvListByRegionPartyWise,
  ] = useState([]);
  const [
    futureODProvListByStatePartyWise,
    setFutureODProvListByStatePartyWise,
  ] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [isRegion, setIsRegion] = useState(false);
  const [loading, setLoading] = useState(false);

  const [lastFileUploadedDate, setLastFileUploadedDate] = useState("");

  const [activeMainTab, setActiveMainTab] = useState("Live");

  const handleMainTabChange = (event, newValue) => {
    setActiveMainTab(newValue);
  };

  useEffect(() => {
    getReportingToListData();
    //loadListData();
    filterData();
    getFutureOverDueDetailsByAsmData("asmEast5");
  }, []);

  const loadListData = () => {
    setLoading(true);
    getConsolidateAgeingReport().then((res) => {
      setLoading(false);
      setAgingReportDataByRegion(res.response.responseMap.dtoListByRegion);
      setInactiveDtoListByRegion(
        res.response.responseMap.inactiveDtoListByRegion
      );
      setDtoListByRegionOdMoreThan150(
        res.response.responseMap.dtoListByRegionOdMoreThan150
      );
      setInactiveDtoListByState(
        res.response.responseMap.inactiveDtoListByState
      );
      setDtoListByStateOdMoreThan150(
        res.response.responseMap.dtoListByStateOdMoreThan150
      );
      setDtoListByPaymentClass(res.response.responseMap.dtoListByPaymentClass);
      setLastFileUploadedDate(res.response.responseMap.lastFileUploadedDate);
      setAgingReportDataByState(res.response.responseMap.dtoListByState);
      setTotalOverdueByRegionByMonthList(
        res.response.responseMap.totalOverdueByRegionByMonthList
      );
      setTotalOverdueByStateByMonthList(
        res.response.responseMap.totalOverdueByStateByMonthList
      );
      setTotalProvisionAmountByRegionByMonthList(
        res.response.responseMap.totalProvisionAmountByRegionByMonthList
      );
      setTotalProvisionAmountByStateByMonthList(
        res.response.responseMap.totalProvisionAmountByStateByMonthList
      );
    });
  };

  const getReportingToListData = (groupId) => {
    //setLoading(true);
    getUserListByGroup(5).then((res) => {
      setAsmList(res.response.responseObject);
      //setLoading(false);
    });
  };

  const getFutureOverDueDetailsByAsmData = (asmLoginId) => {
    setLoading(true);
    getFutureOverDueDetailsByAsm(asmLoginId ?? "").then((res) => {
      setLoading(false);
      setFutureODList(res.response.responseObject);
      setFutureODProvListByRegion(
        res.response.responseMap.futureODProvListByRegion
      );
      setFutureODProvListByState(
        res.response.responseMap.futureODProvListByState
      );
      setFutureODProvListByRegionPartyWise(
        res.response.responseMap.futureODProvListByRegionPartyWise
      );
      setFutureODProvListByStatePartyWise(
        res.response.responseMap.futureODProvListByStatePartyWise
      );
    });
  };
  const [open, setOpen] = useState(false);

  //FILTER STARTS
  const divisionList = [
    {
      label: "Select All",
      value: "Select All",
    },
    {
      label: "Dixcy",
      value: "10",
    },
    {
      label: "Maximus",
      value: "20",
    },
    {
      label: "Levis",
      value: "30",
    },
    {
      label: "Enamor",
      value: "40",
    },
    {
      label: "Thermal",
      value: "50",
    },
  ];

  const filterInitialValues = {
    searchAsm: "",
    searchDivision: "",
  };
  const [searchData, setSearchData] = useState(filterInitialValues);
  const [divisionNameForBlink, setDivisionNameForBlink] = useState("");
  const [selectedDivisionName, setSelectedDivisionName] = useState(
    divisionList
      .filter((d) => d.value !== "40" && d.value !== "Select All")
      .map((d) => d.value)
  );

  const onFilterInputChange = (event) => {
    const { name, value } = event.target;
    searchData[name] = value;
    setSearchData({ ...searchData });
  };
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    /* setSelectedDivisionName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    searchData["searchDivision"] = value;
    setSearchData({ ...searchData }); */

    const isString = typeof value === "string";
    const selected = isString ? value.split(",") : value;
    const allStatesExceptSelectAll = divisionList
      .filter((item) => item.label !== "Select All")
      .map((item) => item.value);

    // Case 1: User just unchecked "Select All"
    const isUncheckingSelectAll =
      selected.includes("Select All") === false &&
      selected.length < selectedDivisionName.length &&
      selectedDivisionName.includes("Select All");

    if (isUncheckingSelectAll) {
      setSelectedDivisionName([]);
      return;
    }

    // Case 2: User checked "Select All"
    if (selected.includes("Select All")) {
      // Select all labels, including "Select All"
      setSelectedDivisionName(divisionList.map((d) => d.value));
      return;
    }

    // Case 3: User manually selected all states except "Select All"
    const filtered = selected.filter((val) => val !== "Select All");

    if (
      filtered.length === allStatesExceptSelectAll.length &&
      !selected.includes("Select All")
    ) {
      setSelectedDivisionName(divisionList); // auto-add "Select All"
    } else {
      setSelectedDivisionName(filtered); // normal case
    }
  };

  const filterData = (val = null) => {
    const selectedDivName =
      selectedDivisionName.length > 4
        ? "All"
        : divisionList
            .filter((div) => selectedDivisionName.includes(div.value))
            //.map((div) => div.label)
            .map((div) => (div.label === "Maximus" ? "Max" : div.label))
            .join(", ");

    setDivisionNameForBlink(selectedDivName);
    //loadListData
    console.log(selectedDivisionName, "selectedDivisionName");
    if (selectedDivisionName.length > 4) {
      loadListData();
      getFutureOverDueDetailsByAsmData(searchData.searchAsm);
    } else {
      setLoading(true);
      getConsolidateAgeingReportWithFilters(
        // searchData.searchDivision,
        val ? val : selectedDivisionName,
        searchData.searchAsm
      ).then((res) => {
        setLoading(false);
        setAgingReportDataByRegion(res.response.responseMap.dtoListByRegion);
        setInactiveDtoListByRegion(
          res.response.responseMap.inactiveDtoListByRegion
        );
        setDtoListByRegionOdMoreThan150(
          res.response.responseMap.dtoListByRegionOdMoreThan150
        );
        setInactiveDtoListByState(
          res.response.responseMap.inactiveDtoListByState
        );
        setDtoListByStateOdMoreThan150(
          res.response.responseMap.dtoListByStateOdMoreThan150
        );
        setDtoListByPaymentClass(
          res.response.responseMap.dtoListByPaymentClass
        );
        setLastFileUploadedDate(res.response.responseMap.lastFileUploadedDate);
        setAgingReportDataByState(res.response.responseMap.dtoListByState);
        setTotalOverdueByRegionByMonthList(
          res.response.responseMap.totalOverdueByRegionByMonthList
        );
        setTotalOverdueByStateByMonthList(
          res.response.responseMap.totalOverdueByStateByMonthList
        );
      });
      getFutureOverDueDetailsByAsmData(searchData.searchAsm);
    }
  };
  //FILTER ENDS

  const exportData = () => {
    setLoading(true);
    exportToExcelAgeingReport(
      moment(new Date()).format("DD_MM_YYYY_HH_mm_SS"),
      activeMainTab,
      selectedDivisionName,
      searchData.searchAsm
    ).then(() => {
      setLoading(false);
    });
  };

  return (
    <Fragment>
      {loading ? <CommonLoader /> : null}
      <Breadcrumb title="Old Ageing Report" />
      {/* <!-- Container-fluid starts--> */}
      <Container fluid={true}>
        <Row>
          <CommonAccordion>
            <Grid container columnSpacing={2} className={classes.muiGrid}>
              <Grid item sm={4} xs={12}>
                <FormControl sx={{ mt: 1, mb: 2, width: 300 }}>
                  <InputLabel
                    id="demo-multiple-checkbox-label"
                    sx={{ top: -8 }}
                  >
                    Select Division
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={selectedDivisionName}
                    onChange={handleChange}
                    input={<OutlinedInput label="Select Division" />}
                    // renderValue={(selected) => selected.join(", ")}
                    renderValue={(selected) =>
                      divisionList
                        .filter((item) => selected.includes(item.value))
                        .map((item) => item.label)
                        .join(", ")
                    }
                    MenuProps={MenuProps}
                  >
                    {divisionList.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={selectedDivisionName.includes(option.value)}
                        />
                        <ListItemText primary={option.label} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <TextField
                  fullWidth
                  id="outlined-select-currency"
                  select
                  label="Division"
                  size="small"
                  //defaultValue=""
                  name="searchDivision"
                  value={searchData.searchDivision}
                  onChange={onFilterInputChange}
                >
                  {divisionList.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField> */}
              </Grid>
              <Grid item sm={4} xs={12}>
                <FormControl sx={{ mt: 1, mb: 2, width: 300 }}>
                  <TextField
                    fullWidth
                    id="outlined-select-currency"
                    select
                    label="ASM"
                    size="small"
                    name="searchAsm"
                    value={searchData.searchAsm}
                    onChange={onFilterInputChange}
                  >
                    {asmList.map((option) => (
                      <MenuItem key={option.username} value={option.username}>
                        {option.name} - {option.username}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>
              <Grid
                item
                sm={4}
                xs={12}
                sx={{
                  margin: "auto",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  type="button"
                  className={classes.btnClass}
                  onClick={() => filterData()}
                >
                  <PersonSearch></PersonSearch>
                </Button>
                <Button
                  color="primary"
                  sx={{ marginLeft: 1 }}
                  variant="contained"
                  type="button"
                  className={classes.btnClass}
                  onClick={() => {
                    setSearchData(filterInitialValues);
                    setSelectedDivisionName(
                      divisionList
                        .filter(
                          (d) => d.value !== "40" && d.value !== "Select All"
                        )
                        .map((d) => d.value)
                    );
                    //loadListData(0, 10);
                    filterData(
                      divisionList
                        .filter(
                          (d) => d.value !== "40" && d.value !== "Select All"
                        )
                        .map((d) => d.value)
                    );
                    getFutureOverDueDetailsByAsmData("asmEast5");
                  }}
                >
                  <Refresh></Refresh>
                </Button>
                <Button
                  color="primary"
                  sx={{ marginLeft: 1 }}
                  variant="contained"
                  type="button"
                  className={classes.btnClass}
                  onClick={() => {
                    exportData();
                  }}
                >
                  <SimCardDownloadRounded></SimCardDownloadRounded>
                </Button>
              </Grid>
            </Grid>
          </CommonAccordion>

          <TabContext value={activeMainTab}>
            <TabList
              onChange={handleMainTabChange}
              indicatorColor="secondary"
              textColor="secondary"
              style={{ background: "white" }}
            >
              <Tab label="Live Details" value="Live" />
              <Tab label="OD/Prov. History" value="History" />
              <Tab label="Future OD/Prov." value="futureOD" />
            </TabList>
            {/* By Region Section Starts*/}
            <TabPanel value="Live">
              <AgeingReportLiveSection
                searchData={searchData}
                agingReportDataByRegion={agingReportDataByRegion}
                agingReportDataByState={agingReportDataByState}
                divisionNameForBlink={divisionNameForBlink}
                inactiveDtoListByRegion={inactiveDtoListByRegion}
                dtoListByRegionOdMoreThan150={dtoListByRegionOdMoreThan150}
                inactiveDtoListByState={inactiveDtoListByState}
                dtoListByStateOdMoreThan150={dtoListByStateOdMoreThan150}
                dtoListByPaymentClass={dtoListByPaymentClass}
              />
              {lastFileUploadedDate && (
                <h6
                  style={{ color: "red" }}
                >{`Live date as on ${lastFileUploadedDate}`}</h6>
              )}
            </TabPanel>
            <TabPanel value="History">
              <AgeingReportHistorySection
                searchData={searchData}
                totalOverdueByRegionByMonthList={
                  totalOverdueByRegionByMonthList
                }
                totalOverdueByStateByMonthList={totalOverdueByStateByMonthList}
                totalProvisionAmountByRegionByMonthList={
                  totalProvisionAmountByRegionByMonthList
                }
                totalProvisionAmountByStateByMonthList={
                  totalProvisionAmountByStateByMonthList
                }
              />
            </TabPanel>
            <TabPanel value="futureOD">
              <AgeingReportFutureOD
                futureODList={futureODList}
                futureODProvListByRegion={futureODProvListByRegion}
                futureODProvListByState={futureODProvListByState}
                futureODProvListByRegionPartyWise={
                  futureODProvListByRegionPartyWise
                }
                futureODProvListByStatePartyWise={
                  futureODProvListByStatePartyWise
                }
              />
            </TabPanel>
          </TabContext>
        </Row>

        <AgeingReportModal
          open={open}
          onCancel={() => {
            setOpen(false);
            setRowData(null);
            setModalData([]);
            setModalDataWithoutDivision([]);
            setIsRegion(false);
          }}
          modalData={modalData}
          modalDataWithoutDivision={modalDataWithoutDivision}
          title={`${
            rowData && (isRegion ? rowData?.regionName : rowData?.stateName)
          } - Ageing Report`}
        />
      </Container>
      {/* <!-- Container-fluid Ends--> */}
      <ToastContainer autoClose={1000} />
    </Fragment>
  );
};

export default OldAgeingReport;
